document.addEventListener("DOMContentLoaded", function() {
  let isLoading = false;
  let nextPageUrl = '{{ collections.next.url }}'; // URL for the next page of collections

  function loadMoreCollections() {
    if (isLoading || !nextPageUrl) return;

    isLoading = true;
    fetch(nextPageUrl)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, 'text/html');
        const newCollections = htmlDoc.querySelector('.collection-list').innerHTML;
        const pagination = htmlDoc.querySelector('.pagination');

        // Append new collections to the existing list
        document.querySelector('.collection-list').insertAdjacentHTML('beforeend', newCollections);

        // Update the next page URL
        if (pagination) {
          const nextLink = pagination.querySelector('a.next');
          nextPageUrl = nextLink ? nextLink.href : null;
        } else {
          nextPageUrl = null;
        }

        isLoading = false;
      })
      .catch(error => {
        console.error('Error loading more collections:', error);
        isLoading = false;
      });
  }

  // Trigger infinite scroll when the user reaches the bottom of the page
  window.addEventListener('scroll', function() {
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;

    if (scrollPosition >= pageHeight - 500 && nextPageUrl) {
      loadMoreCollections();
    }
  });
});